const getSiblings = function (e) {
    let siblings = [];
    if(!e.parentNode) {
        return siblings;
    }
    let sibling = e.parentNode.firstChild;
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;       
    }
    return siblings;
};

const tabsContent = document.querySelectorAll('.tabs-content li');
for (const tab of document.querySelectorAll('.tabs li a')) {
    tab.addEventListener('click', (e) => {
        e.preventDefault();
        tab.classList.add('active');
        const li = tab.parentElement;
        const siblings = getSiblings(li);
        siblings.forEach((sibling) => {
            sibling.querySelector('a').classList.remove('active');
        })
        tabsContent.forEach((content) => {
            const anchor = tab.href.split('#');
            if (content.id == anchor[1]) {
                content.classList.add('active');
                const siblingsContent = getSiblings(content);
                siblingsContent.forEach((sibling) => {
                    sibling.classList.remove('active')
                })
            }
        })
    })
}
/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Enterprise is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Enterprise is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Enterprise, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Enterprise:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Follows a 'code splitting' architecture.
 *  - Is completely custom built (no JS libraries other than instant.page)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Enterprise broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
 *  4.  on:line-item:change
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - product: the product object (includes a list of all variants)
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart. To listen for this, see the
 * on:line-item:change event.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the variant was added
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:line-item:change
 * -------------------------------------------------------------------------------------------------
 * Fires when the quantity of an item already in the cart is updated. Note, if the 'newQuantity' is
 * 0, this indicates the item was removed from that cart.
 *
 * Note, when adding a variant to the cart - this event will fire if that variant is already in the
 * cart (i.e. the quantity is incremented). In this situation, 'on:cart:add' will not fire.
 *
 * How to listen:
 * document.addEventListener('on:line-item:change', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the quantity change was completed
 *   - variantId: id of the variant that was just updated
 *   - newQuantity: new quantity of the line item
 *   - oldQuantity: old quantity of the line item
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes. See the 'Media Queries' section in this file
 * for more.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Enterprise utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 * =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Enterprise only has one third-party dependency: instant.page (https://instant.page/).
 *
 * It's included locally and is only active if it has been enabled in
 * 'Theme Settings > Advanced > Preload links on hover'.
 *
 * Instant.page is a JavaScript library that speeds up page loads by preloading links as soon as the
 * customer hovers over them.
 *
 *
 *
 * =================================================================================================
 * Code Splitting
 * =================================================================================================
 * We followed the ‘code splitting’ technique when building Enterprise.
 *
 * Code splitting consists in writing JavaScript (and CSS)in a modularized way within typically
 * small, more manageable files that can be loaded on-demand, as needed. The idea is to improve the
 * performance of our theme by reducing the amount of code that needs to be loaded upfront.
 *
 * If the customer is visiting a specific page of the theme that requires certain JavaScript
 * functionality, only the code needed for that page will be loaded, rather than one large
 * JavaScript file containing largely unused code. For example, the file media-gallery.js will
 * only be loaded if there is a media gallery on the page.
 *
 * Shopify uses HTTP/2, which is the newer version of the HTTP protocol used to deliver web content.
 * HTTP/2 supports multiplexing, which means that multiple requests can be sent over a single
 * connection at the same time - meaning multiple JS files are essentially served at the speed of a
 * single file.
 *
 * The only JS file which is served on every page in Enterprise is 'main.js'. Main.js contains
 * utility JS which is likely to be needed by many scripts. This is outlined more in the next
 * section.
 *
 *
 *
 * =================================================================================================
 * Utilities
 * =================================================================================================
 * Enterprise provides a few utility utilities, contained in main.js. Some of the key ones are
 * outlined below. See main.js for more.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 1) Lazy Loading
 * -------------------------------------------------------------------------------------------------
 * Lazy loading is a technique for delaying the loading of certain elements until they are needed,
 * which can help improve page load times.
 *
 * We use three functions used for lazy loading images and scripts in our theme:
 *
 *  - setImageSources function - copies the data-src and data-srcset attributes of lazy loaded
 *    images to their src and srcset attributes.
 *  - initLazyImages function - uses the IntersectionObserver API to lazy load images when needed.
 *  - initLazyScript function - only loads a script when a specific element is scrolled into view.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) Cookies
 * -------------------------------------------------------------------------------------------------
 * Cookies are small pieces of data that can be stored on a user's computer. They can be useful for
 * tracking user activity, remembering user preferences or other similar purposes.
 *
 * We use three functions to manage cookies:
 *
 *  - setCookie function - sets a cookie with a given name, value and number of days until it
 *  should expire.
 *  - getCookie function - takes in the name of a cookie to retrieve its value.
 *  - deleteCookie function - takes in the name of a cookie to delete it.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) Media Queries
 * -------------------------------------------------------------------------------------------------
 * The theme creates a theme.mediaMatches object (in theme.liquid) for several key screen sizes
 * specified in our theme, and adds listeners for each media query.
 *
 * These are:
 *
 * mediaQueries: {
 *  sm: '(min-width: 600px)',
 *  md: '(min-width: 769px)',
 *  lg: '(min-width: 1024px)',
 *  xl: '(min-width: 1280px)',
 *  xxl: '(min-width: 1536px)',
 *  portrait: '(orientation: portrait)'
 * }
 *
 * If a breakpoint is crossed, the mediaMatches values are updated and an 'on:breakpoint-change'
 * event is dispatched.
 *
 * You can request the entire theme.mediaMatches object to check which media queries are currently
 * matched. In this case, the returned data will be an object with the names of the media queries as
 * keys, and boolean values indicating whether they are currently matched or not.
 *
 * Example:
 *
 * {
 *  sm: true,
 *  md: true,
 *  lg: true,
 *  xl: true,
 *  xxl: false,
 *  portrait: false
 * }
 *
 * You can reference a specific media query to check if it's currently matched by using:
 * theme.mediaMatches.lg.
 *
 * To check if you're on mobile you can use:
 * !theme.mediaMatches.md
 *
 * If you want to perform some action when the breakpoint changes, you can listen for the
 * breakpoint-change event on the window object.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  // your code here
 * });
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */


/**
 * Sort by prix au m² via App Proxy with filter support.
 * Capture-phase: blocks facet-filters from seeing sqm sort changes.
 * on:facet-filters:updated: re-fetches proxy with current filters.
 */
(function() {
  var PROXY_URL = '/apps/sort/api/sort-collection';
  var activeOrder = null;
  var cache = {};

  function getCollectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^/?]+)/);
    return m ? m[1] : null;
  }
  function getPage() {
    return parseInt(new URLSearchParams(window.location.search).get('page') || '1');
  }
  function getFilterParams() {
    var params = new URLSearchParams(window.location.search);
    var out = [];
    params.forEach(function(v, k) {
      if (k.startsWith('filter.')) out.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    return out.join('&');
  }
  function getGrid() { return document.getElementById('filter-results'); }
  function getUL() {
    var fr = getGrid();
    return fr ? fr.querySelector('[role="list"], ul.grid') : null;
  }

  function buildCard(p) {
    var s = p.image ? p.image.src || '' : '';
    var a = ((p.image && p.image.alt) || p.title || '').replace(/"/g, '&quot;');
    var t = (p.title || '').replace(/"/g, '&quot;');
    var q = p.sqm_price != null ? '\u20AC' + parseFloat(p.sqm_price).toFixed(2).replace('.', ',') + ' / m\u00B2' : '';
    var inv = p.inventory > 0 ? '<div class="pt-5 text-xs product-inventory__status" data-inventory-level="normal">En stock (' + p.inventory + ' unit\u00E9s)</div>' : '';
    var w = (p.image && p.image.width) || 1200, h = (p.image && p.image.height) || 1200;
    var s2 = p.image2 ? p.image2.src || '' : '';
    var a2 = ((p.image2 && p.image2.alt) || p.title || '').replace(/"/g, '&quot;');
    var w2 = (p.image2 && p.image2.width) || 1200, h2 = (p.image2 && p.image2.height) || 1200;
    var hasHover = s2 ? ' has-hover-image' : '';
    var hoverImg = s2 ? '<img src="' + s2 + '&width=460" srcset="' + s2 + '&width=320 320w,' + s2 + '&width=460 460w,' + s2 + '&width=600 600w,' + s2 + '&width=800 800w" sizes="(min-width:1280px) calc((100vw - 200px)/4),(min-width:600px) calc((100vw - 112px)/3),calc(100vw - 40px)" class="img-fit card__hover-image" loading="lazy" width="' + w2 + '" height="' + h2 + '" alt="' + a2 + '">' : '';
    return '<li class="js-pagination-result"><product-card class="card card--product h-full card--no-lines relative flex" data-sqm-price="' + (p.sqm_price||0) + '"><div class="card__media' + hasHover + ' relative"><a href="' + p.url + '" aria-label="' + t + '" class="media block relative js-prod-link" style="padding-top:100%;" tabindex="-1">' + (s ? '<img src="' + s + '&width=460" srcset="' + s + '&width=320 320w,' + s + '&width=460 460w,' + s + '&width=600 600w,' + s + '&width=800 800w" sizes="(min-width:1280px) calc((100vw - 200px)/4),(min-width:600px) calc((100vw - 112px)/3),calc(100vw - 40px)" class="img-fit card__main-image" loading="lazy" width="' + w + '" height="' + h + '" alt="' + a + '">' : '') + hoverImg + '</a></div><div class="card__info-container flex flex-col flex-auto relative"><div class="card__info w-full"><div class="card__info-inner inline-block w-full"><p class="card__title font-bold mt-1 mb-0"><a href="' + p.url + '" class="card-link text-current js-prod-link">' + p.title + '</a></p><div class="price price--top"><div class="price__default"><span class="price_m2">' + q + '</span></div></div>' + inv + '</div></div></div></product-card></li>';
  }

  function buildPag(d, handle, order, filterStr) {
    if (d.total_pages <= 1) return '';
    var b = '/collections/' + handle + '?sort_by=sqm-price-' + order + (filterStr ? '&' + filterStr : '');
    var h = '<nav aria-label="Pagination" data-sqm-pagination><ul class="pagination relative flex flex-wrap justify-center items-center justify-between w-full mx-auto">';
    h += '<li class="pagination__item pagination__item--arrow">';
    h += d.page > 1 ? '<a class="pagination__arrow pagination__arrow--prev hover:lighten flex text-current items-center has-ltr-icon" href="' + b + '&page=' + (d.page-1) + '" data-sqm-page="' + (d.page-1) + '"><span class="pagination__prev-label mis-2">Pr\u00E9c\u00E9dent</span></a>' : '<span class="pagination__arrow" role="link" aria-disabled="true"><span class="pagination__prev-label mis-2">Pr\u00E9c\u00E9dent</span></span>';
    h += '</li><li class="pagination__item text-center md:hidden font-bold">Page ' + d.page + ' / ' + d.total_pages + '</li>';
    for (var i = 1; i <= d.total_pages; i++) {
      if (i === d.page) h += '<li class="hidden md:block"><span class="pagination__page-current font-bold block leading-none">' + i + '</span></li>';
      else if (Math.abs(i - d.page) <= 2 || i === 1 || i === d.total_pages) h += '<li class="hidden md:block"><a class="pagination__page-link text-current block leading-none" href="' + b + '&page=' + i + '" data-sqm-page="' + i + '">' + i + '</a></li>';
      else if (Math.abs(i - d.page) === 3) h += '<li class="hidden md:block"><span class="block leading-none ml-2 mr-2">\u2026</span></li>';
    }
    h += '<li class="pagination__item pagination__item--arrow">';
    h += d.page < d.total_pages ? '<a class="pagination__arrow pagination__arrow--next hover:lighten flex justify-end text-current items-center has-ltr-icon" href="' + b + '&page=' + (d.page+1) + '" data-sqm-page="' + (d.page+1) + '"><span class="pagination__next-label text-end">Suivant</span></a>' : '<span class="pagination__arrow" role="link" aria-disabled="true"><span class="pagination__next-label text-end">Suivant</span></span>';
    h += '</li></ul></nav>';
    return h;
  }

  function bindPag() {
    document.querySelectorAll('[data-sqm-page]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        history.replaceState(null, '', link.href);
        loadProxy(activeOrder, parseInt(link.dataset.sqmPage));
        var ul = getUL();
        if (ul) window.scrollTo({ top: ul.offsetTop - 100, behavior: 'smooth' });
      });
    });
  }

  async function loadProxy(order, page) {
    var handle = getCollectionHandle();
    if (!handle || !order) return;
    var filterStr = getFilterParams();
    var key = handle + '-' + order + '-' + page + '-' + filterStr;
    if (cache[key]) { writeGrid(cache[key].cards, cache[key].pag); return; }
    var ul = getUL();
    if (ul) { ul.style.opacity = '0.4'; ul.style.pointerEvents = 'none'; }
    try {
      var url = PROXY_URL + '?collection=' + handle + '&order=' + order + '&page=' + page;
      if (filterStr) url += '&' + filterStr;
      console.log('[sqm-sort] proxy: ' + order + ' p' + page + (filterStr ? ' +filters' : ''));
      var res = await fetch(url);
      var data = await res.json();
      if (data.error) { console.error('[sqm-sort]', data.error); return; }
      console.log('[sqm-sort] ' + data.products.length + '/' + data.total + ' products, p' + data.page + '/' + data.total_pages);
      var cards = data.products.map(buildCard).join('');
      var pag = buildPag(data, handle, order, filterStr);
      cache[key] = { cards: cards, pag: pag };
      writeGrid(cards, pag);
    } catch (err) {
      console.error('[sqm-sort]', err);
      if (ul) { ul.style.opacity = '1'; ul.style.pointerEvents = ''; }
    }
  }

  function writeGrid(cardsHTML, pagHTML) {
    var fr = getGrid();
    if (!fr) return;
    var ul = fr.querySelector('[role="list"], ul.grid');
    if (ul) {
      ul.innerHTML = cardsHTML;
      ul.style.opacity = '1';
      ul.style.pointerEvents = '';
    } else {
      fr.innerHTML = '<ul class="grid mb-8 md:mb-12 grid-cols-2 small-cards-mobile sm:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-16" role="list">' + cardsHTML + '</ul>';
    }
    var nav = fr.querySelector('nav[aria-label="Pagination"]');
    if (nav) nav.outerHTML = pagHTML || '';
    else if (pagHTML) { ul = fr.querySelector('[role="list"]'); if (ul) ul.insertAdjacentHTML('afterend', pagHTML); }
    bindPag();
    if (typeof initLazyImages === 'function') initLazyImages();
    console.log('[sqm-sort] grid written');
  }

  // === CAPTURE PHASE: intercept sort dropdown BEFORE facet-filters ===
  document.addEventListener('change', function(e) {
    if (!e.target.closest('.products-toolbar__sort, custom-select')) return;
    var val = (e.detail && e.detail.selectedValue) || '';
    if (!val) return;
    if (val === 'sqm-price-asc' || val === 'sqm-price-desc') {
      e.stopPropagation();
      var order = val === 'sqm-price-asc' ? 'asc' : 'desc';
      console.log('[sqm-sort] captured: ' + order);
      activeOrder = order;
      cache = {};
      var handle = getCollectionHandle();
      var filterStr = getFilterParams();
      if (handle) {
        var newUrl = '/collections/' + handle + '?sort_by=' + val;
        if (filterStr) newUrl += '&' + filterStr;
        history.pushState(null, '', newUrl);
      }
      loadProxy(order, 1);
    } else {
      if (activeOrder) {
        console.log('[sqm-sort] deactivated → ' + val);
        activeOrder = null;
        cache = {};
      }
    }
  }, true);

  // === After facet-filters renders (filter change while sqm active) ===
  document.addEventListener('on:facet-filters:updated', function() {
    if (!activeOrder) return;
    // facet-filters pushed a URL without our sort_by — fix it
    var handle = getCollectionHandle();
    var filterStr = getFilterParams();
    if (handle) {
      var fixedUrl = '/collections/' + handle + '?sort_by=sqm-price-' + activeOrder;
      if (filterStr) fixedUrl += '&' + filterStr;
      history.replaceState(null, '', fixedUrl);
    }
    console.log('[sqm-sort] filters changed, re-fetching proxy with ' + activeOrder);
    cache = {};
    loadProxy(activeOrder, 1);
  });

  // === Init ===
  function init() {
    var p = new URLSearchParams(window.location.search);
    var s = p.get('sort_by');
    if (s === 'sqm-price-asc' || s === 'sqm-price-desc') {
      activeOrder = s === 'sqm-price-asc' ? 'asc' : 'desc';
      console.log('[sqm-sort] init ' + activeOrder + ' p' + getPage());
      loadProxy(activeOrder, getPage());
    } else {
      // Prefetch: warm server cache in background so sort is instant when clicked
      var handle = getCollectionHandle();
      if (handle) {
        setTimeout(function() {
          fetch(PROXY_URL + '?collection=' + handle + '&order=asc&page=1')
            .then(function() { console.log('[sqm-sort] prefetch done'); })
            .catch(function() {});
        }, 1500); // delay to not compete with page resources
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('popstate', function() {
    setTimeout(function() {
      var s = new URLSearchParams(window.location.search).get('sort_by');
      if (s === 'sqm-price-asc' || s === 'sqm-price-desc') {
        activeOrder = s === 'sqm-price-asc' ? 'asc' : 'desc';
        cache = {};
        loadProxy(activeOrder, getPage());
      } else { activeOrder = null; }
    }, 200);
  });
})();